<template>
  <div class="sum_contents">
    <h4 class="sum_title rb">{{ title }}</h4>
    <p class="sum_price rm"><span v-if="symbol == 'yen'" class="yen ab">￥</span>{{ price.toLocaleString() }} <span v-if="symbol == 'point'" class="yen ab">P</span></p>
  </div>
</template>

<script>
export default {
  props: ['title', 'price', 'symbol'],
}
</script>

<style lang="css" scoped>
.sum_contents {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.sum_title {
  font-size: 14px;
}
.yen {
  font-size: 12px;
}
.sum_price {
  font-size: 16px;
}
.sum_coupon {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/SumContents.vue